import { Step } from 'react-joyride';

const getProductsTourSteps = (isMobile: boolean): Step[] => {
  const suffix = isMobile ? '-mobile' : '-desktop';

  const allSteps: (Step & { desktopOnly?: boolean })[] = [
    {
      target: '.tour-title',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Bienvenido a <strong>Productos</strong>. Aquí gestionas los productos
          que tu empresa vende, como cremas, cosméticos o cualquier artículo
          que ofrezcas además de tus servicios.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-add-btn',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa <strong>Añadir producto</strong> para crear uno nuevo. Debes
          indicar:
          <ul style={{ margin: '8px 0 0 16px' }}>
            <li>
              <strong>Nombre</strong> del producto
            </li>
            <li>
              <strong>Descripción</strong> (opcional)
            </li>
            <li>
              <strong>Precio</strong> en euros
            </li>
            <li>
              Si estará <strong>activo</strong> o no
            </li>
          </ul>
          <br />
          Puedes añadir una <strong>imagen</strong> para que el producto se vea
          mejor en la lista y de cara a los clientes.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-filter-input',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Usa este buscador para encontrar rápidamente un producto por su
          nombre. Muy útil cuando el catálogo empieza a crecer.
        </div>
      ),
      placement: 'bottom',
      disableBeacon: true,
    },
    {
      target: '.tour-table-head',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Esta es la <strong>lista de productos</strong>. De un vistazo ves la
          imagen, el nombre, la descripción, el precio y el estado de cada uno.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: '.tour-activo-badge',
      content: (
        <div style={{ textAlign: 'justify' }}>
          <strong>Estado</strong> indica si el producto está activo.
          <br />
          <br />
          <span style={{ color: '#10B981', fontWeight: 'bold' }}>✔ Sí</span>{' '}
          — el producto está visible y disponible.
          <br />
          <span style={{ color: '#EF4444', fontWeight: 'bold' }}>✘ No</span>{' '}
          — queda oculto y no disponible, pero conserva su información. Útil
          cuando te quedas sin existencias temporalmente.
        </div>
      ),
      placement: 'right',
      disableBeacon: true,
      desktopOnly: true,
    },
    {
      target: `.tour-edit-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa el <strong>lápiz ✏️</strong> para editar un producto: cambiar
          su nombre, descripción, precio, imagen o estado.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: `.tour-delete-btn${suffix}`,
      content: (
        <div style={{ textAlign: 'justify' }}>
          Pulsa la <strong>papelera 🗑️</strong> para eliminar un producto. Te
          pedirá confirmación antes de borrarlo definitivamente.
          <br />
          <br />
          Si solo quieres dejar de mostrarlo un tiempo (por ejemplo, sin stock),
          es mejor <strong>editarlo y desactivarlo</strong> en lugar de
          borrarlo.
        </div>
      ),
      placement: 'left',
      disableBeacon: true,
    },
    {
      target: '.tour-pagination',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Si tienes muchos productos, usa la <strong>paginación</strong> para
          moverte entre páginas y ajustar cuántos ver a la vez.
        </div>
      ),
      placement: 'top',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: (
        <div style={{ textAlign: 'justify' }}>
          Al crear o editar un producto se abre un <strong>formulario</strong>{' '}
          donde defines su información básica, precio, imagen y visibilidad.
          <br />
          <br />
          <strong>Consejo:</strong> usa nombres claros y descripciones breves
          para que los clientes entiendan fácilmente qué están comprando.
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
  ];

  return allSteps
    .filter((s) => !(isMobile && s.desktopOnly))
    .map(({ desktopOnly, ...step }) => step);
};

export default getProductsTourSteps;